import { format } from 'date-fns'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Fragment } from 'react'
import { Button } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { getDoner } from '../../../helper/BackendHelper'
import { curencyFormater } from '../../../helper/formater'
import DonerPanUpdate from '../../components/Common/DonerPanUpdate'
import PageLoader from '../../layouts/PageLoader'
import PageTitle from '../../layouts/PageTitle'
import DonationHistory from './DonationHistory'

const initialData = {
}

const VolunteerEdit = () => {
    const [formData, setformData] = useState(initialData);
    const [isLoading, setIsLoading] = useState(false);

    const [donerData, setDonerData] = useState();

    const { id } = useParams();


    const onChangeValue = (e) => {
        setformData({ ...formData, [e?.currentTarget?.name]: e?.currentTarget?.value })
    }

    useEffect(() => {
        if (id) {
            setIsLoading(true)
            getDonerByID(id);
        }

    }, [id])

    const getDonerByID = (id) => {
        getDoner(id).then((res) => {
            if (res?.status === 'success') {
                setDonerData(res?.data)
                setIsLoading(false)

            }
        })
    }

    // console.log({ donerData });



    const formSubmit = async (e) => {
        e.preventDefault();
        // setIsLoading(true);

        // const res = await addUser(formData);

        // if (res?.status === 'success') {

        //     swal("Good job!", `Donner added`, "success")
        //     setIsLoading(false);
        //     router.push('/list-of-donors')

        // } else {

        //     swal("Oops", `${res?.response?.data?.message ? res?.response?.data?.message : res?.message}`, "error")
        //     setIsLoading(false);

        // }
    }

    return (
        <Fragment>
            <PageLoader isLoading={isLoading} >
                {/* <PageTitle activeMenu="Users Edit" motherMenu="Users" /> */}
                {
                    donerData && (
                        <div className="row">
                            <div className="col-xl-8">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body pb-3 d-flex flex-wrap justify-content-between align-items-center">
                                                <div className="user-bx-2 me-3 mb-3">

                                                    <div>
                                                        <h3 className="fs-20 font-w700">{donerData?.name}</h3>
                                                        <span className="font-w400">{donerData?.email}</span>
                                                    </div>
                                                </div>
                                                <div className="me-3 mb-3">
                                                    <p className="mb-2">Phone Number</p>
                                                    <h4 className="mb-0">{donerData?.phone}</h4>
                                                </div>
                                                <div className="me-3 mb-3">
                                                    <p className="mb-2">PAN Number</p>
                                                    <h4 className="mb-0">{donerData?.pan}</h4>
                                                </div>
                                                <div className="me-3 mb-3">
                                                    <p className="mb-2">Registered on</p>
                                                    <h4 className="mb-0">{donerData?.created_at ? format(new Date(donerData?.created_at), "MMM dd, yyyy") : null}</h4>
                                                </div>

                                            </div>


                                        </div>
                                    </div>
                                    {
                                        donerData?.donation?.length > 0 && (
                                            <div className="col-lg-12">
                                                <DonationHistory donation={donerData?.donation} />

                                            </div>
                                        )
                                    }


                                </div>

                            </div>

                            <div className="col-xl-4">
                                <div className="row">

                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body action">
                                                <div className="">

                                                    <h4 className="fs-32 font-w800 text-white mt-3">{curencyFormater.format(donerData?.donatedAmount)}</h4>
                                                    <span className="fs-18 font-w600 text-white">Total Amount Donated</span>

                                                </div>
                                            </div>
                                            {/* {
                                                donerData?.donatedAmount > 0 && (
                                                    <div className="card-body">
                                                        <div className="d-flex justify-content-between">
                                                            <div className="text-center">
                                                                <svg className="mb-1" width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <rect width="62" height="62" rx="20" fill="#FFAA2B" />
                                                                    <path d="M39.1667 18.1667H22.8334C21.5957 18.1667 20.4088 18.6584 19.5336 19.5335C18.6584 20.4087 18.1667 21.5957 18.1667 22.8334V31C18.1667 31.3094 18.2897 31.6062 18.5085 31.825C18.7272 32.0438 19.024 32.1667 19.3334 32.1667H25.1667V42.6667C25.1662 42.8898 25.2297 43.1085 25.3496 43.2966C25.4695 43.4848 25.6409 43.6346 25.8434 43.7284C26.0464 43.8218 26.272 43.855 26.4933 43.824C26.7145 43.7929 26.9223 43.699 27.0917 43.5534L30.4167 40.7067L33.7417 43.5534C33.9531 43.7341 34.222 43.8334 34.5001 43.8334C34.7782 43.8334 35.0471 43.7341 35.2584 43.5534L38.5834 40.7067L41.9084 43.5534C42.1197 43.7341 42.3887 43.8334 42.6667 43.8334C42.8355 43.8322 43.0023 43.7964 43.1567 43.7284C43.3593 43.6346 43.5306 43.4848 43.6506 43.2966C43.7705 43.1085 43.834 42.8898 43.8334 42.6667V22.8334C43.8334 21.5957 43.3418 20.4087 42.4666 19.5335C41.5914 18.6584 40.4044 18.1667 39.1667 18.1667ZM20.5001 29.8334V22.8334C20.5001 22.2145 20.7459 21.621 21.1835 21.1834C21.6211 20.7459 22.2146 20.5 22.8334 20.5C23.4523 20.5 24.0457 20.7459 24.4833 21.1834C24.9209 21.621 25.1667 22.2145 25.1667 22.8334V29.8334H20.5001ZM41.5001 40.135L39.3417 38.28C39.1304 38.0993 38.8615 37.9999 38.5834 37.9999C38.3053 37.9999 38.0364 38.0993 37.8251 38.28L34.5001 41.1267L31.1751 38.28C30.9638 38.0993 30.6948 37.9999 30.4167 37.9999C30.1387 37.9999 29.8697 38.0993 29.6584 38.28L27.5001 40.135V22.8334C27.4986 22.0137 27.2813 21.209 26.8701 20.5H39.1667C39.7856 20.5 40.3791 20.7459 40.8167 21.1834C41.2542 21.621 41.5001 22.2145 41.5001 22.8334V40.135ZM39.1667 24C39.1667 24.3094 39.0438 24.6062 38.825 24.825C38.6062 25.0438 38.3095 25.1667 38.0001 25.1667H31.0001C30.6907 25.1667 30.3939 25.0438 30.1751 24.825C29.9563 24.6062 29.8334 24.3094 29.8334 24C29.8334 23.6906 29.9563 23.3939 30.1751 23.1751C30.3939 22.9563 30.6907 22.8334 31.0001 22.8334H38.0001C38.3095 22.8334 38.6062 22.9563 38.825 23.1751C39.0438 23.3939 39.1667 23.6906 39.1667 24ZM39.1667 28.6667C39.1667 28.9761 39.0438 29.2729 38.825 29.4916C38.6062 29.7104 38.3095 29.8334 38.0001 29.8334H31.0001C30.6907 29.8334 30.3939 29.7104 30.1751 29.4916C29.9563 29.2729 29.8334 28.9761 29.8334 28.6667C29.8334 28.3573 29.9563 28.0605 30.1751 27.8417C30.3939 27.6229 30.6907 27.5 31.0001 27.5H38.0001C38.3095 27.5 38.6062 27.6229 38.825 27.8417C39.0438 28.0605 39.1667 28.3573 39.1667 28.6667ZM39.1667 33.3334C39.1667 33.6428 39.0438 33.9395 38.825 34.1583C38.6062 34.3771 38.3095 34.5 38.0001 34.5H31.0001C30.6907 34.5 30.3939 34.3771 30.1751 34.1583C29.9563 33.9395 29.8334 33.6428 29.8334 33.3334C29.8334 33.0239 29.9563 32.7272 30.1751 32.5084C30.3939 32.2896 30.6907 32.1667 31.0001 32.1667H38.0001C38.3095 32.1667 38.6062 32.2896 38.825 32.5084C39.0438 32.7272 39.1667 33.0239 39.1667 33.3334Z" fill="white" />
                                                                </svg>
                                                                <h4 className="fs-18 font-w700">Send Receipts</h4>
                                                            </div>

                                                        </div>
                                                    </div>
                                                )
                                            } */}

                                        </div>
                                    </div>
                                    {/* <div className="col-lg-12">
                                        <DonerPanUpdate userId={donerData.id} />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    )
                }

            </PageLoader>
        </Fragment>
    )
}

export default VolunteerEdit